import script from "./ZoneWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoneWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ZoneWrapper.vue?vue&type=style&index=0&id=08852ee8&lang=scss"

const __exports__ = script;

export default __exports__